import React, { useRef, useState } from "react";

const CreateFbPost = ({ isOpen, onClose, fetchpostsList }) => {
  const [apiResponse, setApiResponse] = useState("");
  const [postText, setPostText] = useState("");
  const [image, setImage] = useState(null);
  const fileInputRef = useRef(null);

  const handlePostTextChange = (e) => {
    setPostText(e.target.value);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Check if both name and image are provided
    if (postText) {
      const formData = new FormData();
      formData.append("text", postText);
      formData.append("image", image);

      createFbPostAPI(formData);
    } else {
      console.error("Name and image are required");
    }
  };

  const createFbPostAPI = (formData) => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/facebook/posts`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          onClose();
          fetchpostsList();
          // close popup and refresh the list
          // Clear form fields
          setPostText("");
          setImage(null);
          // Optionally, clear the file input field
          fileInputRef.current.value = "";
        } else {
          setApiResponse(data.error);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        // Handle errors
        setApiResponse(error.messag);
      });
  };

  return (
    <div className={`popup ${isOpen ? "open" : ""}`}>
      <div className="popup-content popup-content-500">
        <span className="popup-close" onClick={onClose}>
          &times;
        </span>
        <h2>Add New Post</h2>

        <form onSubmit={handleSubmit}>
          <div>
            <textarea id="post_text" className="input_field" name="post_text" rows="15" cols="30" placeholder="Enter post text here" value={postText} onChange={handlePostTextChange}></textarea>
          </div>
          <div>
            <input type="file" id="image" className="input_field" name="image" accept="image/*" onChange={handleImageChange} ref={fileInputRef} />
          </div>

          <button type="submit" className="big_button">
            Submit
          </button>

          <p>{apiResponse}</p>
        </form>
      </div>
    </div>
  );
};

export default CreateFbPost;
